import { MANIFEST_MODELS } from '@squiz/dx-json-schema-lib';

export type JobManifestV1Model = MANIFEST_MODELS.JobV1.JobManifest;
export type JobManifestModel = JobManifestV1Model;
export type SchemaVersions = keyof typeof MANIFEST_MODELS;
export const JOB_SCHEMA_VERSIONS = Object.keys(MANIFEST_MODELS).filter((model) => model.includes('JobV'));
